export default __webpack_public_path__ + "static/media/img_gas_phase_04.01b904f4.png";